import { LANGUAGE_LOCALSTORAGE_KEY } from './constants'

const ALLOWED_LANGUAGES = ['cs', 'en', 'de', 'pl'] as const

function normalizeLanguage(language: string | null | undefined) {
    if (!language) return null

    const cleanLanguage = language.toString().replace(/"/g, '').trim().toLowerCase()
    const languageCode = cleanLanguage.split(/[-_]/)[0]

    if (ALLOWED_LANGUAGES.includes(languageCode as typeof ALLOWED_LANGUAGES[number])) {
        return languageCode
    }

    return null
}

export function getLanguage() {
    const localStorageLang = normalizeLanguage(localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY))

    if (localStorageLang) return localStorageLang

    const htmlLang = normalizeLanguage(document.documentElement.lang)

    if (htmlLang) return htmlLang

    // @ts-ignore - Legacy compatibility
    const browserLanguage = normalizeLanguage(navigator.language || navigator.userLanguage)

    if (browserLanguage) return browserLanguage

    return 'en'
}
